import { createFileRoute } from '@tanstack/react-router'
import { SalesOverviewPage } from '@/features/sales-overview/sales-overview-page'

export const Route = createFileRoute('/_authenticated/projects/sales-overview')({
  staticData: { title: 'Sales Overview' },
  component: SalesOverviewPage,
})
